import { X } from 'lucide-react';
import { forwardRef, type HTMLAttributes } from 'react';

import { AutoneTooltip, cn } from '../../../../tailwind';

type FilterChipProps = {
  id: string;
  filterName: string;
  filterCondition: string;
  filterPostfix: string | number;
  onFilterRemove?: (filterName: string) => void;
  showX?: boolean;
} & HTMLAttributes<HTMLDivElement>;

export const FilterChip = forwardRef<HTMLDivElement, FilterChipProps>(
  (
    {
      id,
      filterName,
      filterCondition,
      filterPostfix,
      onFilterRemove,
      className,
      showX,
      ...props
    },
    ref,
  ) => {
    return (
      <div
        className={cn(
          'gap-2 border-[1px] border-secondary-20 py-1.5 px-4 flex rounded-2xl text-sm font-semibold items-center bg-white',
          className,
        )}
        {...props}
        ref={ref}
      >
        <AutoneTooltip
          text={`${filterName} ${filterCondition} ${filterPostfix}`}
          side="bottom"
          arrow={false}
        >
          <div className="flex text-nowrap gap-1 max-w-40">
            <span className="truncate">
              {filterName}{' '}
              <span className="text-grey-60">{filterCondition}</span>{' '}
              {filterPostfix}
            </span>
          </div>
        </AutoneTooltip>
        {showX && (
          <X
            className="w-3 h-3 text-grey-80 cursor-pointer"
            onClick={() => onFilterRemove?.(id)}
            data-testid="filter-chip-remove"
          />
        )}
      </div>
    );
  },
);
